import React from "react"
import { Form, Button } from "antd"
import SiteSurveysCompressorsFormPiece from "./SiteSurveysCompressorsFormPiece"
import { PlusOutlined } from "@ant-design/icons"

function SiteSurveysCompressorsForm(props) {
    /////*** event handler methods start ***/////
    const handleRemove = (field, remove) => {
        let allValues = props.form.getFieldValue()

        if (!!allValues.compressors_attributes[field.name]) {
            if (!!allValues.compressors_attributes[field.name]["site_survey_id"]) {
                let updatedFieldsToRemove = [...props.toRemove]
                updatedFieldsToRemove.push({ ...allValues.compressors_attributes[field.name], _destroy: true })
                props.setToRemove(updatedFieldsToRemove)
            }
        }
        remove(field.name)
    }
    /////*** event handler methods end ***/////

    return (
        <div id={"site-surveys-compressors-form"} className={"card"}>
            <Form.List name={"compressors_attributes"}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field) => (
                            <SiteSurveysCompressorsFormPiece {...field} form={props.form} key={field.key} remove={() => handleRemove(field, remove)} />
                        ))}
                        <Form.Item className={"add-field"}>
                            <Button block onClick={() => add()} icon={<PlusOutlined />}>
                                Add field
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </div>
    )
}

export default SiteSurveysCompressorsForm
